import React from 'react';
import { LoadRow, isCriticalLoad } from '../useLoadsData';
import { statusColorByName } from '../statusMeta';
import styles from './LoadsTable.module.css';

// Abre el detalle del load en una ventana aparte (popup), tal cual V1 (ReportsTable).
const openLoadDetail = (id: string) => {
  const newWindow = window.open('', '', 'width=1500,height=1000');
  if (newWindow) {
    newWindow.opener = null;
    newWindow.location.href = `/guide/detail/${id}`;
  }
};

interface LoadsTableProps {
  /**
   * Las filas **de esta página**, ya recortadas por el servidor.
   *
   * ⚠️ Antes llegaba el arreglo completo y la tabla lo rebanaba con `page`/`pageSize`. Al paginar del
   * lado del servidor esos dos parámetros sobran, y dejarlos habría sido peor que inútil: rebanar una
   * página ya rebanada deja la tabla **vacía** a partir de la segunda página, porque el `offset` se
   * aplicaría dos veces.
   */
  data: LoadRow[];
}

const formatDate = (text?: string | null): string => {
  if (!text || text === '1970-01-01T00:00:00.000Z') return '';
  const d = new Date(text);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString();
};

const COLUMNS = [
  'Office',
  'DYLO ID',
  'Status',
  'Carrier',
  'Operation Type',
  'Origin',
  'Destination',
  'Mode',
  '# Truck/Container',
  'Create Date',
];

const LoadsTable: React.FC<LoadsTableProps> = ({ data }) => {
  const rows = data;

  if (rows.length === 0) {
    return <div className={styles.empty}>No loads match your search.</div>;
  }

  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            {COLUMNS.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => {
            const critical = isCriticalLoad(row);
            const statusName = row.status?.name;
            const color = statusColorByName(statusName);
            return (
              <tr
                key={row.id}
                className={[styles.row, critical ? styles.criticalRow : '']
                  .filter(Boolean)
                  .join(' ')}
                style={{ animationDelay: `${Math.min(idx, 14) * 25}ms` }}
                onClick={() => openLoadDetail(row.id)}
              >
                <td>{row.loadOffice?.name || ''}</td>
                <td className={styles.strong}>{row.pro_number || ''}</td>
                <td>
                  {statusName && (
                    <span
                      className={styles.pill}
                      style={{ background: `${color}1A`, color }}
                    >
                      {statusName.toUpperCase()}
                    </span>
                  )}
                </td>
                <td>{row.carrier?.name || ''}</td>
                <td>{row.operation_type || ''}</td>
                <td>{row.origin || ''}</td>
                <td>{row.destiny || ''}</td>
                <td>{row.mode_name || ''}</td>
                <td>{row.trailer || ''}</td>
                <td>{formatDate(row.created_date)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LoadsTable;
